import { render, staticRenderFns } from "./PlanTypesBlock.vue?vue&type=template&id=d52676f4&scoped=true&"
import script from "./PlanTypesBlock.vue?vue&type=script&lang=js&"
export * from "./PlanTypesBlock.vue?vue&type=script&lang=js&"
import style0 from "./PlanTypesBlock.vue?vue&type=style&index=0&id=d52676f4&lang=scss&"
import style1 from "./PlanTypesBlock.vue?vue&type=style&index=1&id=d52676f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d52676f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d52676f4')) {
      api.createRecord('d52676f4', component.options)
    } else {
      api.reload('d52676f4', component.options)
    }
    module.hot.accept("./PlanTypesBlock.vue?vue&type=template&id=d52676f4&scoped=true&", function () {
      api.rerender('d52676f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/blocks/PlanTypesBlock.vue"
export default component.exports